module.exports = __webpack_public_path__ + "static/hostjane-subreddit-04cbc334c79fc6eb49abdc66ceae2a5b.jpg";